import React, { memo, useState } from "react";
import { array, string, func } from "prop-types";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";

import style from "./style.module.scss";
import { formatPercent, getLevel, getInverseLevel, isSameId } from "./utils";

// Table is expanded by default when there are only a few labels
const AUTO_EXPAND_MAX_LABELS = 3;

export default memo(CompareLabelTable);

CompareLabelTable.propTypes = {
  comparisons: array, // ready comparisons only
  activeKey: string,
  selectedLabelId: string,
  onSelectLabel: func,
};

function CompareLabelTable({
  comparisons,
  activeKey,
  selectedLabelId,
  onSelectLabel,
}) {
  const active =
    comparisons.find((comparison) => comparison.key === activeKey) ||
    comparisons[0];
  const labelTypes = active?.result?.labelTypes || [];
  const [isOpen, setIsOpen] = useState(
    labelTypes.length <= AUTO_EXPAND_MAX_LABELS
  );

  if (!labelTypes.length) return null;

  return (
    <div className={style.labelTableSection}>
      <div className={style.labelTableHeader}>
        <button
          type="button"
          className={style.tableToggle}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <ExpandMore /> : <ChevronRight />}
          Theo label type ({labelTypes.length})
        </button>

        {comparisons.length > 1 && (
          <span className={style.labelTableSource}>{active.title}</span>
        )}
      </div>

      {isOpen && (
        <table className={style.compareTable}>
          <thead>
            <tr>
              <th>Label</th>
              <th>Khớp</th>
              <th>Thiếu</th>
              <th>Thừa</th>
            </tr>
          </thead>
          <tbody>
            {labelTypes.map((item) => (
              <tr
                key={item.labelId}
                className={
                  isSameId(item.labelId, selectedLabelId) ? style.rowActive : ""
                }
                onClick={() => onSelectLabel(item.labelId)}
                title="Lọc shape theo label này"
              >
                <td className={style.labelCell}>{item.labelTypeName}</td>
                <td className={style[`cell_${getLevel(item.matchPercentage)}`]}>
                  {formatPercent(item.matchPercentage)}
                </td>
                <td
                  className={
                    style[`cell_${getInverseLevel(item.missingPercentage)}`]
                  }
                >
                  {formatPercent(item.missingPercentage)}
                </td>
                <td
                  className={
                    style[`cell_${getInverseLevel(item.redundantPercentage)}`]
                  }
                >
                  {formatPercent(item.redundantPercentage)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
